import { render, staticRenderFns } from "./HomeFocus.vue?vue&type=template&id=b48603c8&scoped=true"
import script from "./HomeFocus.vue?vue&type=script&lang=js"
export * from "./HomeFocus.vue?vue&type=script&lang=js"
import style0 from "./HomeFocus.vue?vue&type=style&index=0&id=b48603c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b48603c8",
  null
  
)

export default component.exports